<!-- ----------------------------------------------- -->
<template>
  <div align="start" id="map-emergency-info" class="ma-0 pa-0">
    <!-- [pc]緊急お知らせ -->
    <div
      v-if="
        isPcMode && emergencyInfo && Object.keys(emergencyInfo).length !== 0
      "
    >
      <v-list
        v-for="info in emergencyInfo"
        :key="info.infoManageCod"
        dense
        class="emergency-info pa-0 com-info-height"
      >
        <v-list-group no-action>
          <template v-slot:activator>
            <v-list-item class="pa-0">
              <v-list-item-content class="ml-2 pa-0">
                <v-list-item-subtitle class="emergency-info-text-color">
                  <span style="white-space: normal;">{{ info.summary }}</span>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </template>
          <div
            class="emergency-info-scroll info-contents-text-color white pl-12 pa-2 test"
          >
            <div
              style="white-space: pre-wrap;"
              class="info-contents-text-color"
              v-html="info.detail"
            ></div>
            <v-btn
              v-if="checkString(info.infoManageCode)"
              outlined
              small
              color="success"
              class="em-info-button"
              @click="linkUrl(info.infoManageCode)"
            >
              <v-icon left>link</v-icon>
              <span>{{ text.detail }}</span>
            </v-btn>
          </div>
        </v-list-group>
      </v-list>
    </div>
    <!-- [mb]緊急お知らせ -->
    <div v-if="!isPcMode && emergencyInfo && Object.keys(emergencyInfo).length !== 0">
      <v-list
        v-for="(info, index) in emergencyInfo"
        :key="info.infoManageCod"
        dense
        class="mb-emergency-info pa-0 com-info-height"
      >
        <v-list-item
          class="emergency-info-item pa-0"
          @click="openEmergencyInfoDlg(index)"
        >
          <v-list-item-content class="ml-2 pa-0">
            <v-list-item-subtitle
              class="emergency-info-text-color summary-text"
              >{{ info.summary }}</v-list-item-subtitle
            >
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </div>
    <!-- [pc]任意お知らせ -->
    <div v-if="isPcMode && anyInfo && Object.keys(anyInfo).length !== 0">
      <v-list
        v-for="info in anyInfo"
        :key="info.infoManageCod"
        dense
        class="any-info pa-0 com-info-height"
      >
        <v-list-group no-action>
          <template v-slot:activator>
            <v-list-item class="pa-0">
              <v-list-item-content class="ml-2 pa-0">
                <v-list-item-subtitle class="any-info-title-text-color">
                  <span style="white-space: normal;">{{ info.summary }}</span>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </template>
          <div
            class="any-info-scroll info-contents-text-color white pl-12 pa-2 test"
          >
            <span
              style="white-space: pre-wrap;"
              class="info-contents-text-color"
              v-html="info.detail"
            ></span>
          </div>
        </v-list-group>
      </v-list>
    </div>
    <!-- [mb]任意お知らせ -->
    <div v-if="!isPcMode && anyInfo && Object.keys(anyInfo).length !== 0">
      <v-list
        v-for="(info, index) in anyInfo"
        :key="info.infoManageCod"
        dense
        class="mb-any-info pa-0 com-info-height"
      >
        <v-list-item class="any-info-item pa-0" @click="openAnyInfoDlg(index)">
          <v-list-item-content class="ml-2 pa-0">
            <v-list-item-subtitle
              class="any-info-title-text-color summary-text"
              >{{ info.summary }}</v-list-item-subtitle
            >
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </div>
  </div>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 緊急お知らせ
 * EmergencyInfo.vue
 * @author LIS
 */
import mixin from "./../../lib/mixin.js";

export default {
  /** タグ名 */
  name: "map-emergency-info",
  mixins: [mixin],
  data() {
    return {
      /** 文字列リソース */
      text: {
        detail: "詳細",
      },
    };
  },
  computed: {
    /** モード */
    isPcMode: {
      get() {
        return this.$store.state.app.mode == "pc";
      },
    },
    /** 緊急お知らせ件数 */
    numberEmergency: {
      get() {
        var len = this.$store.state.info.emergency.length;
        return len;
      },
    },
    /** 緊急お知らせ1件目 */
    firstEmergency: {
      get() {
        var info = this.$store.state.info.emergency[0];
        return info;
      },
    },
    /** 緊急お知らせ */
    emergencyInfo: {
      get() {
        return this.$store.state.info.emergency;
      },
    },
    /** 任意お知らせ */
    anyInfo: {
      get() {
        return this.$store.state.info.any;
      },
    },
  },
  methods: {
    /** 緊急お知らせダイアログ表示 */
    openEmergencyInfoDlg(index) {
      // 地図上のダイアログを全て非表示
      this.$store.commit("map/dialogAllClose");
      // モバイルモード初期表示(全てのダイアログを非表示)
      this.routerPush("/mb");
      this.$store.commit("app/setContent", "");
      this.$store.commit("map/setShowEmergencyInfoDlg", true);
      this.$store.commit("info/setEmergencyInfoIndex", index);
    },
    /** 任意お知らせダイアログ表示 */
    openAnyInfoDlg(index) {
      // 地図上のダイアログを全て非表示
      this.$store.commit("map/dialogAllClose");
      // モバイルモード初期表示(全てのダイアログを非表示)
      this.routerPush("/mb");
      this.$store.commit("app/setContent", "");
      this.$store.commit("map/setShowAnyInfoDlg", true);
      this.$store.commit("info/setAnyInfoIndex", index);
    },
    /** お知らせ情報詳細画面に遷移 */
    linkUrl(infoManageCd) {
      let infoDetailUrl = this.$router.resolve({
        path: "/pcfull/info/detail",
        query: {
          infmgcd: infoManageCd,
          fld: this.$store.state.app.fldCtlParty,
        },
      });
      window.open(infoDetailUrl.href, "_blank");
    },
    /** 文字列チェック */
    checkString(str) {
      if (str == null || str == "") {
        return false;
      }
      return true;
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped>
@import "./../../scss/kwb.scss";
@import "./../../scss/color.scss";

#map-emergency-info {
  position: absolute;
  z-index: 3029;
  width: 100%;
  top: 0;
  left: 0;
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
    0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
  .emergency-info {
    border-radius: 0px;
    background-color: $color-emergency-info-back;
    .emergency-info-scroll {
      font-size: 13px;
      overflow-y: auto;
      max-height: 30vh;
    }
  }
  .any-info {
    border-radius: 0px;
    background-color: $color-any-info-header-back;
    .any-info-scroll {
      font-size: 13px;
      overflow-y: auto;
      max-height: 30vh;
    }
  }
  .mb-emergency-info {
    border-radius: 0px;
    width: 100%;
    background-color: $color-emergency-info-back;
    .emergency-info-item {
      min-height: 34px;
    }
    .summary-text {
      font-size: 0.8rem;
    }
  }
  .mb-any-info {
    border-radius: 0px;
    width: 100%;
    background-color: $color-any-info-header-back;
    .any-info-item {
      min-height: 34px;
    }
    .summary-text {
      font-size: 0.8rem;
    }
  }
  .emergency-info-text-color {
    color: $color-emergency-info-text;
  }
  .any-info-title-text-color {
    color: $color-any-info-text;
  }
  .info-contents-text-color {
    color: $color-card-contents-text;
  }
}
</style>
